var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryTshirt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.948 40.762h14.064v63.289a2.343 2.343 0 0 0 2.344 2.344H85.3a2.343 2.343 0 0 0 2.344-2.344V40.762h14.064a2.345 2.345 0 0 0 2.33-2.086l2.344-21.096a2.344 2.344 0 0 0-1.587-2.482l-35.16-11.72a2.349 2.349 0 0 0-2.522.698c-6.094 7.466-18.473 7.461-24.567 0a2.351 2.351 0 0 0-2.523-.698l-35.16 11.72a2.344 2.344 0 0 0-1.589 2.482l2.344 21.096a2.344 2.344 0 0 0 2.33 2.086z",
    fill: "#E3E3E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryTshirt);
export default __webpack_public_path__ + "static/media/category-tshirt.b4355fa53a8543f94e3b01a511cea3cb.svg";
export { ForwardRef as ReactComponent };